module.exports = __webpack_public_path__ + "img/chat9.887b5503.png";